import { useParams } from 'react-router-dom';

export const useProjectNumber = (): string | undefined => {
  const params = useParams();

  return params.projectNumber;
};
